//   getTaskSession({ id: 3423, taskType: 'single', clientId: 3424, taskId: 155 }).unwrap();
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { convertToMomentDate, userFullName } from "helpers/common";
import React, { useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useLocation, useParams } from "react-router-dom";
// import { useGetTaskSessionStaffMutation } from "store/services/staff";
import Switch from "react-switch";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import { getGoalTrackingPercentage } from "helpers/common";
import TrackerRangeSlider from "components/ReportComponents/TrackerRangeSlider/Index";
import { useLazyGetSupportStaffClientTaskSessionViewQuery } from "store/services/supportStaff";
import { GOAL_TRACK_PARAMETERS } from "config/constants";
import ViewAttachments from "./ViewAttachments";
import SessionOutcomePieChart from "components/ReportComponents/SessionOutcomePieChart";
import { NoRecordFound } from "components/Common/Common";
import NotesComponent from "components/shared/FormComponents/NotesComponent";
import { useGetNoteQuery } from "store/services/note";
import moment from "moment";
// import SessionOutcomePieChart from "components/ReportComponents/SessionOutcomePieChart";
// import AnswerTracker from "components/shared/ReportComponents/AnswerFields/AnswerTracker";

const ClientTaskSessionView = () => {
  const { taskId, clientId, staffId, taskType } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const task_datetime = queryParams.get('task_datetime');
  const [checked, setChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [getTaskSessionView, { data, isLoading, isError }] = useLazyGetSupportStaffClientTaskSessionViewQuery();
  const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
  // const { data: noteDetails } = useGetNoteQuery({ clientId: taskId, moduleName: `task_occurence_${moment(task_datetime).format("YYYY-MM-DD")}` });
  const { data: noteDetails } = useGetNoteQuery({ clientId: taskId, moduleName: `task_occurence` });


  useEffect(() => {
    const fetchData = async () => {
      const payload = { task_datetime };
      try {
        // const response = await getTaskSession({ id: 3423, taskType: 'single', clientId: 3424, taskId: 155 }).unwrap();
        const response = await getTaskSessionView({ id: staffId, taskType: 'single', clientId, taskId, payload }).unwrap();

        if (response.status === "failure") {
          setErrorMessage(response.message);
        }
      } catch (err) {
        console.error("Error getting progress data", err);
        setErrorMessage("An unexpected error occurred. Please try again later.");
      }
    };

    fetchData();
  }, [task_datetime, taskId, clientId, staffId, taskType]);

  // Extracting data from the API response
  const taskData = data;
  const associatedTasks = taskData?.associatedTasks;
  const associatedMapping = taskData?.associatedMapping;
  const associatedClient = taskData?.associatedClient;
  const taskProgress = taskData?.associatedTaskProgress ?? associatedMapping;

  const therapist = associatedTasks?.owner;



  // Safely parse task_data if it exists
  let trackerData = {};
  try {
    trackerData = taskProgress?.task_data ? JSON.parse(taskProgress.task_data) : {};
  } catch (error) {
    console.error("Error parsing task_data:", error);
  }

  const attendanceStatus = associatedMapping?.attendance == "present" ? "Present" : "Absent";

  const handleViewPdf = async (name) => {

    try {
      const url = await getFileUrl(name).unwrap();
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };

  return (
    <>
      <section className='mt-3 border-bottom'>
        <Container fluid>
          <Row className='justify-content-between align-items-center'>
            <Col lg='6'>
              <p className='mb-0'>
                <Link to={-1} className="themeClr">Clients</Link>
                {" "}/{" "}
                <span className='mb-0' style={{ fontWeight: "600" }}>View Session</span>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {isLoading ? (
        <LoadingIndicator />
      ) : isError || errorMessage ? (
        <ErrorComponent message={errorMessage || "An error occurred while fetching data."} />
      ) : (
        <section>
          <section className='mt-4'>
            <Container fluid>
              <Row>
                <Col lg='6'>
                  <Row>
                    <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Task Title
                        </h6>
                        <p className="m-0 themeBlue pt-2">
                          {data?.associatedTasks?.task_title}
                        </p>
                      </div>
                    </Col>
                    <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Name of Discipline
                        </h6>
                        <p className="m-0 themeBlue pt-2">
                          {therapist?.therapist_detail?.therapist_discipline?.name}
                        </p>
                      </div>
                    </Col>
                    <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Client Name
                        </h6>
                        <p className="m-0 themeBlue pt-2">
                          {userFullName(associatedClient)}
                        </p>
                      </div>
                    </Col>
                    <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Attendance
                        </h6>
                        <div className="mt-2 d-flex align-items-center">
                          <span>Absent</span>
                          <Switch
                            className="mx-2"
                            uncheckedIcon={""}
                            checkedIcon={""}
                            onHandleColor={"#A3DF00"}
                            offHandleColor={"#A3DF00"}
                            onColor={"#E6E6E6"}
                            offColor={"#E6E6E6"}
                            height={18}
                            width={40}
                            checked={attendanceStatus === "Present"}
                            onChange={(checked) => setChecked(checked)}
                            disabled={true}
                          />
                          <span>Present</span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col lg='6'>
                  <Row className='justify-content-end pe-2 align-items-start'>
                    <Col lg="4" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded border-bottom">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Target Date
                        </h6>
                        <div className='d-flex pt-2 align-items-center'>
                          <p className="m-0 themeBlue ms-1">
                            {convertToMomentDate(taskData?.createdAt)}
                          </p>
                        </div>
                      </div>
                      {/* <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          End Date
                        </h6>
                        <div className='d-flex pt-2 align-items-center'>
                          <p className="m-0 themeBlue ms-1">
                            {convertToMomentDate(associatedTasks?.ends_on_data?.endDate)}
                          </p>
                        </div>
                      </div> */}
                    </Col>
                  </Row>
                </Col>

                <Col lg="6" sm="12" className="my-3">
                  {/* <h6 className="m-0 themeBlue fw-sbold">Notes</h6> */}
                  <NotesComponent
                    // allRecordsHeading={"All Intructions"}
                    disablePin={true}
                    disableAdd={true}
                    disableEdit={true}
                    // showAllMessage={"Show All"}
                    // heading="Clinician's Instructions"
                    // buttonName="Create"
                    notes={noteDetails}
                    className={`form-control`}
                    // module={`task_occurence_${moment(task_datetime).format("YYYY-MM-DD")}`}
                    module={`task_occurence`}
                    client_id={taskId}
                  />
                </Col>

                <Col md="12" sm="6" className='my-2'>
                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                    <h6 className="m-0 themeBlue fw-bold">
                      <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                      Description
                    </h6>
                    <p className="m-0 themeBlue pt-2">
                      {associatedTasks?.description || "--"}
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className='mt-4'>
            <Container fluid>
              <Row className="border-bottom">
                <Col lg="12">
                  <div className='px-2 py-3 rounded' style={{ backgroundColor: "#B46C9F1F" }}>
                    <p className='mb-0' style={{ color: "#071E3E" }}>
                      <span className='px-2 py-2 rounded me-3' style={{ backgroundColor: "#B46C9F33", color: "#82777f", fontWeight: "700" }}>Clinician's instructions</span>
                      {associatedTasks?.clinical_instruction || "--"}
                    </p>
                  </div>
                </Col>
                <Col lg="6" className="my-2">
                  <ViewAttachments
                    attachments={associatedTasks?.documents}
                    handleViewPdf={handleViewPdf}
                    title={"Documents :"}
                  />
                </Col>
                <Col lg="6" className="my-2">
                  <ViewAttachments
                    attachments={associatedTasks?.resources}
                    handleViewPdf={handleViewPdf}
                    title={"Resources :"}
                  />
                </Col>
              </Row>
            </Container>
          </section>

          {
            data?.associatedTaskProgress || (data?.associatedMapping && data?.associatedTasks?.duration == "no_repeat") ?
              <section className='my-4'>
                <Container fluid>
                  <Row>
                    <Col lg="6">
                      {
                        trackerData?.tracker?.percentage &&
                        <div>
                          <label className="fw-semibold my-3">Tracker</label>
                          <div className="py-2">
                            <div className="position-relative">
                              <div className="d-flex align-items-start flex-column justify-content-between gap-10 w-100">
                                <TrackerRangeSlider
                                  labels={['Infrequent', 'Frequent']}
                                  value={trackerData?.tracker?.percentage || 0}
                                >
                                  <input
                                    value={trackerData?.tracker?.percentage || 0}
                                    id="frequency-range"
                                    className="frequency-range"
                                    type={"range"}
                                    min="0"
                                    max="100"
                                    disabled={true}
                                  />
                                </TrackerRangeSlider>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <div>
                        <div className="py-2">
                          <div className="position-relative">
                            <label className="fw-semibold my-3">Description</label>
                            <p className="form-control rounded-3 bg-white h-auto" rows={5}>
                              {trackerData?.answer || "No answer provided"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="py-2">
                        <div className="position-relative">
                          <ul className="list-unstyled">
                            <ViewAttachments
                              attachments={trackerData.files}
                              handleViewPdf={handleViewPdf}
                              title={"Attachments:"}
                            />
                          </ul>
                        </div>
                      </div>
                    </Col>
                    {
                      trackerData?.goalTracking &&
                      <Col lg="6" className="my-2">
                        <div className="cardCstm rounded-3" style={{ background: "#F7F0F5" }}>
                          <div className="top p-3 border-bottom">
                            <h6 style={{ fontSize: 14 }} className="m-0 fw-bold text-uppercase">
                              Session Outcomes
                            </h6>
                          </div>
                          <div className="contentBody p-3">
                            <Row>
                              <Col lg="5" className="my-2">
                                <SessionOutcomePieChart
                                  trackingData={
                                    trackerData?.goalTracking
                                  }
                                />
                              </Col>
                              <Col lg="7" className="my-2">
                                {trackerData?.goalTracking?.length > 0 ? (
                                  <ul className="list-unstyled ps-0 mb-0">
                                    {Object.entries(GOAL_TRACK_PARAMETERS)?.map(([param, label], index) => {
                                      let parameterPercentage = getGoalTrackingPercentage(param, trackerData?.goalTracking);
                                      return (
                                        <li
                                          key={index}
                                          className="py-1 d-flex align-items-center justify-content-between gap-10"
                                        >
                                          <p className="m-0">
                                            <span className="fw-sbold">
                                              {param}
                                            </span>{" "}
                                            -{label}
                                          </p>
                                          <p className="m-0 fw-bold">
                                            <span className="px-2">
                                              {
                                                parameterPercentage
                                              }
                                            </span>
                                            %
                                          </p>
                                        </li>
                                      );
                                    }
                                    )}
                                  </ul>
                                ) : (
                                  <p>
                                    Goal not tracked yet
                                  </p>
                                )}
                              </Col>
                            </Row>
                          </div>
                          {/* <div className="contentBody p-3">
                      <Row>
                        <Col lg="7" className="my-2">
                          <p>Tracker Percentage: {trackerData?.tracker?.percentage || 0}%</p>
                        </Col>
                      </Row>
                    </div> */}
                        </div>
                      </Col>
                    }
                  </Row>
                </Container>
              </section>
              :
              <section className='my-4'>
                <div className={`w-100  d-flex align-items-center justify-content-center py-2 mt-2 bg-transparent `}>
                  Support staff has not submitted the required data yet.
                </div>
              </section>

          }

        </section>
      )}
    </>
  );
};

export default ClientTaskSessionView;